import { BrowserRouter, Routes, Route } from "react-router-dom";
import Menu from "./components/Menu";
import Tkwaymenu from "./components/Tkwaymenu";
import { useParams } from "react-router-dom";
import Cart from "./components/Cart";
import TKWAYCart from "./components/tkwaycart"; 
import { AddressProvider } from "./context/AddressContext";
import { LoadingProvider } from "./context/LoadingContext";
import GlobalLoading from "./components/GlobalLoading";
import { LanguageProvider } from "./context/LanguageContext";
import WifiConnectPage from "./WifiConnectPage";
import "./styles/CustomerTheme.css";

function OrderMenu() {
  const { tableNo } = useParams();
  return tableNo?.toUpperCase().includes('TKWAY') ? <Tkwaymenu /> : <Menu />;
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AddressProvider>
          <LoadingProvider>
            <GlobalLoading />
            <Routes>
              <Route path="/:storeId/:tableNo" element={<WifiConnectPage />} />
              <Route path="/order/:storeId/:tableNo" element={<OrderMenu />} />
              {/* <Route path="/takeaway/:storeId/:tableNo" element={<Tkwaymenu />} /> */}
              <Route path="/oldmenu/order/:storeId/:tableNo" element={<Tkwaymenu />} />
              <Route path="/cart/:storeId/:tableNo" element={<Cart />} />
              <Route path="/tkwaycart/:storeId/:tableNo" element={<TKWAYCart />} />
            </Routes>
          </LoadingProvider>
        </AddressProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;